/* t5: selected v4 classes, isolated from Dawn core classes. Source hash and adaptations recorded in version document. */
(()=>{'use strict';if(window.DBSourceCommerce)return;
const define=(name,ctor)=>{if(!customElements.get(name))customElements.define(name,ctor)};
const dispatch=(target,name,detail={})=>target.dispatchEvent(new CustomEvent(name,{bubbles:true,detail}));
const itemProperty=(item,name)=>item?.properties?.[name]==null?'':String(item.properties[name]);
const isFullCart=state=>Array.isArray(state?.items)&&Number.isFinite(state.item_count)&&Number.isFinite(state.total_price);
const parseJsonScript=root=>{try{return JSON.parse(root.querySelector('script[type="application/json"]')?.textContent||'[]')}catch{return []}};
const selectedValues=root=>Array.from(root.querySelectorAll('select')).map(select=>select.value);
const findVariant=(variants,values)=>variants.find(variant=>values.every((value,index)=>String(variant.options?.[index])===String(value)));
const syncVariantSelects=(root,variant)=>root?.querySelectorAll('select').forEach((select,index)=>{if(variant.options?.[index]!=null)select.value=String(variant.options[index])});
const resolveSelectableVariant=(root,variants,options={})=>{const selected=findVariant(variants,selectedValues(root));if(selected&&(selected.available||!options.skipUnavailable))return selected;if(!selected&&!options.skipNonExistent)return null;const fallback=variants.find(v=>v.available);if(fallback)syncVariantSelects(root,fallback);return fallback||null};
const formatMoney=(cents,format)=>window.Shopify?.formatMoney?Shopify.formatMoney(cents,format):new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:JSON.parse(document.getElementById('DBCommerceConfig')?.textContent||'{}').currency||'USD'}).format((Number(cents)||0)/100);
class DynamicDates extends HTMLElement {
    connectedCallback() {
      const days = (this.dataset.dayLabels || '').split(',').map((value) => value.trim()).filter(Boolean);
      const months = (this.dataset.monthLabels || '').split(',').map((value) => value.trim()).filter(Boolean);
      this.skippedDays = this.parseSkippedDays(this.dataset.daysToSkip || '');
      this.skippedDates = this.parseSkippedDates(this.dataset.datesToSkip || '');
      this.querySelectorAll('[data-dynamic-date="true"]').forEach((element) => {
        const min = Number(element.dataset.minDays || 0);
        const max = Number(element.dataset.maxDays || min);
        const template = element.dataset.text || element.textContent;
        element.innerHTML = template
          .replace(/\[start_date\]/g, this.format(this.addDaysSkipping(min), days, months))
          .replace(/\[end_date\]/g, this.format(this.addDaysSkipping(max), days, months));
      });
    }

    parseSkippedDays(value) {
      const aliases = {
        sun: 0, sunday: 0, '周日': 0, '星期日': 0, '星期天': 0,
        mon: 1, monday: 1, '周一': 1, '星期一': 1,
        tue: 2, tues: 2, tuesday: 2, '周二': 2, '星期二': 2,
        wed: 3, wednesday: 3, '周三': 3, '星期三': 3,
        thu: 4, thur: 4, thurs: 4, thursday: 4, '周四': 4, '星期四': 4,
        fri: 5, friday: 5, '周五': 5, '星期五': 5,
        sat: 6, saturday: 6, '周六': 6, '星期六': 6,
      };
      return new Set(String(value).split(',').map((part) => {
        const normalized = part.trim().toLocaleLowerCase();
        if (/^[0-6]$/.test(normalized)) return Number(normalized);
        return aliases[normalized];
      }).filter((day) => day !== undefined));
    }

    parseSkippedDates(value) {
      return String(value).split(',').map((part) => part.trim()).filter(Boolean).map((part) => {
        const match = part.match(/^(?:(\d{4})[-/.])?(\d{1,2})[-/.](\d{1,2})$/);
        return match ? { year: Number(match[1]) || null, month: Number(match[2]), day: Number(match[3]) } : null;
      }).filter(Boolean);
    }

    isSkipped(date) {
      if (this.skippedDays.has(date.getDay())) return true;
      return this.skippedDates.some((item) => (
        (!item.year || item.year === date.getFullYear())
        && item.month === date.getMonth() + 1
        && item.day === date.getDate()
      ));
    }

    addDaysSkipping(amount) {
      const value = new Date();
      value.setHours(12, 0, 0, 0);
      let remaining = Math.max(0, Number(amount) || 0);
      if (this.skippedDays.size === 7 || !Number.isFinite(remaining)) throw new Error('Configure at least one working day and a finite delivery estimate.');
      while (this.isSkipped(value) || remaining > 0) {
        value.setDate(value.getDate() + 1);
        if (!this.isSkipped(value) && remaining > 0) remaining -= 1;
      }
      return value;
    }

    format(date, days, months) {
      const format = this.dataset.dateFormat || 'month_day';
      const month = months[date.getMonth()] || date.toLocaleString(document.documentElement.lang || 'en', { month: 'short' });
      const day = days[(date.getDay() + 6) % 7] || date.toLocaleString(document.documentElement.lang || 'en', { weekday: 'short' });
      const number = date.getDate();
      const numeric = `${number}.${date.getMonth() + 1}.`;
      switch (format) {
        case 'day_mm_dd': return `${day}, ${month} ${number}`;
        case 'day_dd_mm': return `${day}, ${number}. ${month}`;
        case 'mm_dd': return `${month} ${number}`;
        case 'dd_mm': return `${number}. ${month}`;
        case 'dd_mm_no_dot': return `${number} ${month}`;
        case 'day_dd_mm_numeric': return `${day}, ${numeric}`;
        case 'dd_mm_numeric': return numeric;
      }
      if (format.includes('day_month')) return `${day}, ${date.getDate()} ${month}`;
      if (format.includes('numeric')) return date.toLocaleDateString(document.documentElement.lang || 'en');
      return `${day}, ${month} ${date.getDate()}`;
    }
  }
define('v4-dynamic-dates',DynamicDates);
class CustomProductField extends HTMLElement {
    connectedCallback() {
      this.fieldController?.abort();
      this.fieldController = new AbortController();
      const productInfo = this.closest('product-info');
      const section = productInfo?.dataset.section || this.dataset.section || '';
      const escapedSection = window.CSS?.escape ? CSS.escape(String(section)) : String(section);
      const form = productInfo?.querySelector(`#product-form-${escapedSection}`)
        || productInfo?.querySelector('form[data-type="add-to-cart-form"]')
        || document.getElementById(`product-form-${section}`) || this.closest('form');
      const controls = Array.from(this.querySelectorAll('input:not([type="hidden"]), textarea, select'));
      const control = controls[0];
      if (!form || !control || !this.dataset.name) return;
      if (!form.getAttribute('id')) form.setAttribute('id', `product-form-${section || Math.random().toString(36).slice(2)}`);
      const propertyName = `properties[${this.dataset.name}]`;
      controls.forEach((item) => {
        item.name = propertyName;
        item.setAttribute('form', form.getAttribute('id'));
      });
      const required = this.dataset.required === 'true' || control.required;
      controls.forEach((item) => { item.required = required; });
      this.validate = (report = false) => {
        const radios = this.querySelectorAll('input[type="radio"]');
        const checked = this.querySelector('input[type="radio"]:checked');
        const value = radios.length ? (checked?.value || '') : (control.value || '');
        controls.forEach((item) => item.setCustomValidity(''));
        const missingRequired = required && !String(value).trim();
        const message = missingRequired
          ? (this.dataset.atcErrorMsg || this.querySelector('.input-error-msg')?.textContent?.trim() || 'Please complete this field.')
          : '';
        control.setCustomValidity(message);
        const invalid = missingRequired || !control.checkValidity();
        control.setAttribute('aria-invalid', String(invalid));
        this.classList.toggle('field-error', invalid);
        if (report && invalid) {
          control.reportValidity();
          control.focus?.();
        }
        return !invalid;
      };
      this.addEventListener('change', () => this.validate(false), {signal:this.fieldController.signal});
      this.addEventListener('input', () => this.validate(false), {signal:this.fieldController.signal});
      this.validate(false);
    }
    disconnectedCallback() { this.fieldController?.abort(); }
  }
define('v4-custom-product-field',CustomProductField);
class InternalVideo extends HTMLElement {
    connectedCallback() {
      if (this.dataset.runtimeBound) {
        document.addEventListener('fullscreenchange', this.onFullscreenChange);
        if (this.video && this.dataset.autoplay === 'true') this.observe();
        return;
      }
      this.dataset.runtimeBound = 'true';
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.timeline = this.querySelector('.internal-video__timeline');
      this.querySelectorAll('[data-play], .internal-video__play, .play-btn').forEach((button) => button.addEventListener('click', () => this.toggle()));
      this.querySelectorAll('[data-sound], .internal-video__sound, .internal-video__sound-btn').forEach((button) => button.addEventListener('click', () => this.toggleSound()));
      this.querySelectorAll('[data-fullscreen], .internal-video__fullscreen-btn').forEach((button) => button.addEventListener('click', () => this.toggleFullscreen()));
      this.video.addEventListener('play', () => this.updatePlaybackState());
      this.video.addEventListener('pause', () => this.updatePlaybackState());
      this.video.addEventListener('ended', () => this.updatePlaybackState());
      this.video.addEventListener('waiting', () => this.classList.add('internal-video--loading'));
      this.video.addEventListener('playing', () => this.classList.remove('internal-video--loading'));
      this.video.addEventListener('timeupdate', () => this.updateTimeline());
      this.onFullscreenChange = () => this.classList.toggle('internal-video--fullscreen', document.fullscreenElement === this);
      document.addEventListener('fullscreenchange', this.onFullscreenChange);
      if (this.timeline) {
        this.timeline.setAttribute('role', 'slider');
        this.timeline.setAttribute('aria-valuemin', '0');
        this.timeline.setAttribute('aria-valuemax', '100');
        if (this.timeline.tabIndex < 0) this.timeline.tabIndex = 0;
        this.timeline.addEventListener('pointerdown', (event) => this.startTimelineDrag(event));
        this.timeline.addEventListener('keydown', (event) => this.onTimelineKeydown(event));
      }
      this.updatePlaybackState();
      this.updateSoundState();
      this.updateTimeline();
      if (this.dataset.autoplay === 'true') this.observe();
    }

    toggle() {
      if (this.video.paused) this.video.play().catch(() => {});
      else this.video.pause();
    }

    updatePlaybackState() {
      const playing = !this.video.paused && !this.video.ended;
      this.dataset.playing = String(playing);
      this.classList.toggle('internal-video--playing', playing);
    }

    toggleSound() {
      this.video.muted = !this.video.muted;
      this.updateSoundState();
    }

    updateSoundState() {
      const muted = this.video.muted;
      this.dataset.muted = String(muted);
      this.classList.toggle('internal-video--muted', muted);
      this.querySelectorAll('[data-sound], .internal-video__sound, .internal-video__sound-btn').forEach((button) => {
        button.setAttribute('aria-pressed', String(!muted));
      });
    }

    toggleFullscreen() {
      if (document.fullscreenElement === this) document.exitFullscreen?.();
      else this.requestFullscreen?.().catch?.(() => {});
    }

    updateTimeline() {
      if (!this.timeline) return;
      const percent = this.video.duration > 0 ? (this.video.currentTime / this.video.duration) * 100 : 0;
      this.timeline.style.setProperty('--completed', `${percent}%`);
      this.timeline.setAttribute('aria-valuenow', String(Math.round(percent)));
    }

    seekFromPointer(event) {
      if (!this.timeline || !(this.video.duration > 0)) return;
      const rect = this.timeline.getBoundingClientRect();
      const ratio = Math.max(0, Math.min(1, (event.clientX - rect.left) / Math.max(1, rect.width)));
      this.video.currentTime = ratio * this.video.duration;
      this.updateTimeline();
    }

    startTimelineDrag(event) {
      event.preventDefault();
      this.timeline.setPointerCapture?.(event.pointerId);
      this.seekFromPointer(event);
      const move = (moveEvent) => this.seekFromPointer(moveEvent);
      const stop = () => {
        this.timeline.removeEventListener('pointermove', move);
        this.timeline.removeEventListener('pointerup', stop);
        this.timeline.removeEventListener('pointercancel', stop);
      };
      this.timeline.addEventListener('pointermove', move);
      this.timeline.addEventListener('pointerup', stop);
      this.timeline.addEventListener('pointercancel', stop);
    }

    onTimelineKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key) || !(this.video.duration > 0)) return;
      event.preventDefault();
      if (event.key === 'Home') this.video.currentTime = 0;
      else if (event.key === 'End') this.video.currentTime = this.video.duration;
      else this.video.currentTime = Math.max(0, Math.min(this.video.duration, this.video.currentTime + (event.key === 'ArrowRight' ? 5 : -5)));
      this.updateTimeline();
    }

    observe() {
      this.observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) this.video.play().catch(() => {});
        else this.video.pause();
      }, { threshold: 0.35 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('fullscreenchange', this.onFullscreenChange);
    }
  }
define('v4-internal-video',InternalVideo);
class QuantityGifts extends HTMLElement {
    connectedCallback() {
      if (this.dataset.runtimeBound) return;
      this.dataset.runtimeBound = 'true';
      const escapedSection = window.CSS?.escape
        ? CSS.escape(String(this.dataset.section || ''))
        : String(this.dataset.section || '');
      const productInfo = this.closest('product-info') || this.closest('.product__info-container') || this.closest('.shopify-section');
      this.quantityInput = productInfo?.querySelector(
        `#Quantity-${escapedSection}, #quantity-${escapedSection}, .quantity__input[name="quantity"]`
      );
      this.onQuantityInputChange = () => this.update();
      this.quantityInput?.addEventListener('change', this.onQuantityInputChange);
      this.onQuantityBreakChange = (event) => {
        if (String(event.detail?.section || '') !== String(this.dataset.section || '')) return;
        this.update(event.detail.quantity);
      };
      document.addEventListener('quantity-break:change', this.onQuantityBreakChange);
      this.update();
    }

    update(quantity = Number(this.quantityInput?.value || 1)) {
      this.querySelectorAll('.quantity-gift').forEach((gift) => {
        const unlocked = quantity >= Number(gift.dataset.quantity || 1);
        gift.dataset.unlocked = String(unlocked);
        gift.classList.toggle('quantity-gift--unlocked', unlocked);
        const form = gift.querySelector('product-form, form');
        if (form) form.dataset.selected = String(unlocked);
      });
      dispatch(this, 'quantity-gifts:change', { quantity });
    }

    disconnectedCallback() {
      document.removeEventListener('quantity-break:change', this.onQuantityBreakChange);
      this.quantityInput?.removeEventListener('change', this.onQuantityInputChange);
      delete this.dataset.runtimeBound;
    }
  }
define('v4-quantity-gifts',QuantityGifts);
class BundleDeals extends HTMLElement {
    connectedCallback() {
      if (this.dataset.runtimeBound) return;
      this.dataset.runtimeBound = 'true';
      this.addEventListener('change', (event) => {
        if (event.target.matches('.bundle-deals__checkbox-js')) event.target.dataset.checked = String(event.target.checked);
        if (event.target.matches('.bundle-deals__variant-selects-js select')) this.updateVariant(event.target.closest('.bundle-deals__variant-selects-js'));
        this.refresh();
      });
      this.querySelectorAll('.bundle-deals__variant-selects-js').forEach(container=>this.updateVariant(container));
      this.refresh();
    }

    updateVariant(container) {
      const variants = parseJsonScript(container);
      const variant = findVariant(variants, selectedValues(container));
      const index = container.dataset.index;
      const checkbox = this.querySelector(`.bundle-deals__checkbox-js[data-index="${index}"]`);
      if (!checkbox) return;
      if (!variant) { checkbox.disabled=true;checkbox.checked=false;checkbox.dataset.id='';return; }
      checkbox.dataset.id = variant.id;
      checkbox.dataset.price = Number(variant.price || 0);
      checkbox.dataset.comparePrice = Math.max(Number(variant.compare_at_price || 0), Number(variant.price || 0));
      checkbox.disabled = !variant.available;
      if (!variant.available) checkbox.checked = false;
    }

    discount(price, percentageLeft = 1, fixedDiscount = 0) {
      const multiplier = Math.min(1, Math.max(0, Number(percentageLeft)));
      const fixed = Math.max(0, Number(fixedDiscount || 0));
      return Math.max(0, Math.round(Number(price || 0) * multiplier - fixed));
    }

    refresh() {
      const selected = Array.from(this.querySelectorAll('.bundle-deals__checkbox-js:checked:not(:disabled)')).filter(item=>/^\d+$/.test(item.dataset.id || ''));
      const itemTotal = selected.reduce((sum, item) => sum + this.discount(item.dataset.price, item.dataset.percentageLeft, item.dataset.fixedDiscount), 0);
      const itemCompare = selected.reduce((sum, item) => sum + this.discount(item.dataset.comparePrice, item.dataset.percentageLeft, item.dataset.fixedDiscount), 0);
      const total = this.discount(itemTotal, this.dataset.percentageLeft, this.dataset.fixedDiscount);
      const compare = Math.max(total, this.discount(itemCompare, this.dataset.percentageLeft, this.dataset.fixedDiscount));
      const priceNode = this.querySelector('.bundle-deals__total-price-js');
      const compareNode = this.querySelector('.bundle-deals__total-compare-price-js');
      if (this.dataset.updatePrices !== 'false') {
        if (priceNode) priceNode.textContent = formatMoney(total, this.dataset.moneyFormat);
        if (compareNode) {
          compareNode.textContent = compare > total ? formatMoney(compare, this.dataset.moneyFormat) : '';
          compareNode.hidden = compare <= total;
        }
      }
      const variantsHost = this.querySelector('.product-form__variants');
      if (variantsHost) {
        variantsHost.innerHTML = '';
        selected.forEach((item) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'items[][id]';
          input.value = item.dataset.id;
          variantsHost.append(input);
          const quantity = document.createElement('input');
          quantity.type = 'hidden';
          quantity.name = 'items[][quantity]';
          quantity.value = '1';
          variantsHost.append(quantity);
        });
      }
      const submit = this.querySelector('[type="submit"]');
      if (submit) submit.disabled = selected.length === 0;
      dispatch(this, 'bundle:change', { items: selected.map((item) => Number(item.dataset.id)), total });
    }
  }
define('v4-bundle-deals',BundleDeals);
class ContentTabs extends HTMLElement{constructor(){super(),this.activeButtonClass="true"==this.dataset.productTabs?"active":"content-tab-button--active",this.buttons=this.querySelectorAll(".content-tab-button-js"),this.tabs=this.querySelectorAll(".content-tab"),this.tabsContainer=this.querySelector(".content-tabs__tabs-js"),this.activeButton=this.querySelector(`.${this.activeButtonClass}`),this.activeTab=this.querySelector(".content-tab--active"),this.isMovingAnimation="moving"===this.dataset.animation,this.isMovingAnimation&&(this.activeBg=this.querySelector(".content-tab-buttom__active-bg"),this.handleActiveBg(),this.activeBg.style.transitionDuration="0.4s"),this.setHeight(),this.buttons.forEach(t=>{t.addEventListener("click",this.handleClick.bind(this))}),this.onResize=()=>{this.setHeight(),this.isMovingAnimation&&this.handleActiveBg()},window.addEventListener("resize",this.onResize)}connectedCallback(){window.addEventListener("resize",this.onResize);this.onResize()}disconnectedCallback(){window.removeEventListener("resize",this.onResize)}handleClick(t){this.activeButton=t.currentTarget,this.buttons.forEach(t=>{t.classList.remove(this.activeButtonClass)}),this.activeButton.classList.add(this.activeButtonClass),this.tabs.forEach(t=>{t.classList.remove("content-tab--active"),t.dataset.index===this.activeButton.dataset.index&&(this.activeTab=t)}),this.activeTab.classList.add("content-tab--active"),this.setHeight(),this.isMovingAnimation&&this.handleActiveBg()}setHeight(){this.activeTab&&(this.tabsContainer.style.height=this.activeTab.clientHeight+"px")}handleActiveBg(){this.activeBg.style.width=this.activeButton.getBoundingClientRect().width+"px",this.activeBg.style.height=this.activeButton.getBoundingClientRect().height+"px",this.activeBg.style.top=this.activeButton.offsetTop+"px",this.activeBg.style.left=this.activeButton.offsetLeft+"px"}}
define('v4-content-tabs',ContentTabs);
class CopyButton extends HTMLElement{constructor(){super(),this.textarea=document.createElement("textarea"),this.textarea.classList.add("visually-hidden"),this.textarea.value=this.dataset.content.trim(),this.appendChild(this.textarea),this.addEventListener("click",this.handleClick.bind(this))}handleClick(t){this.textarea.select(),document.execCommand("copy"),this.dataset.success="true",setTimeout(()=>this.dataset.success="false",3e3)}}
define('v4-copy-button',CopyButton);
class PageScrollProgress extends HTMLElement{connectedCallback(){this.track=this.querySelector(".page-progress__track"),this.fill=this.querySelector(".page-progress__fill"),this.update=this.update.bind(this),window.addEventListener("scroll",this.update),window.addEventListener("resize",this.update),this.update()}disconnectedCallback(){window.removeEventListener("scroll",this.update);window.removeEventListener("resize",this.update)}update(){let t=document.documentElement,e=window.pageYOffset||t.scrollTop,i=t.scrollHeight-t.clientHeight;this.fill.style.width=(i>0?Math.round(e/i*100):0)+"%"}}
define('v4-page-scroll-progress',PageScrollProgress);
class ResultsContainer extends HTMLElement{constructor(){super(),this.styleType=this.dataset.style,this.duration=parseInt(this.dataset.duration,10)||650,this.initDelay=parseInt(this.dataset.delay,10)||0,this.observer=new IntersectionObserver(t=>{t.forEach(t=>{t.isIntersecting&&(setTimeout(()=>this.animateAll(),this.initDelay),this.observer.disconnect())})},{threshold:.3})}connectedCallback(){this.observer.observe(this)}animateAll(){let t=this.querySelectorAll(".results__percentage");t.forEach(t=>{let e=parseInt(t.dataset.percentage,10)||0;this.animateRow(t,e)})}animateRow(t,e){let i=t.querySelector("p"),s=performance.now();if("circle"===this.styleType){let n=t.querySelector(".ring__prog");n&&requestAnimationFrame(()=>{n.setAttribute("stroke-dasharray",`${e} 100`)})}let r=t=>{let n=Math.min((t-s)/this.duration,1);i&&(i.textContent=`${Math.round(n*e)}%`),n<1&&requestAnimationFrame(r)};requestAnimationFrame(r)}}
define('v4-results-container',ResultsContainer);
const hotspotButtons=[];
function registerHotspotButton(t){hotspotButtons.push(t)}function unregisterHotspotButton(t){let e=hotspotButtons.indexOf(t);-1!==e&&hotspotButtons.splice(e,1)}document.addEventListener("mousedown",function(t){for(let e of hotspotButtons)"true"!==e.dataset.open||e.contains(t.target)||e.closeModal()});
class HotspotButton extends HTMLElement{constructor(){super(),this.button=this.querySelector(".hotspot-btn"),this.content=this.querySelector(".hotspot__content"),this.type=this.dataset.type,this.openEvent=this.dataset.openEvent,this.header=document.querySelector(".section-header"),this.stickyHeader=document.querySelector("sticky-header"),this.mobileOverlay=this.querySelector(".hotspot-overlay"),this.button.addEventListener("click",this.toggleModal.bind(this)),"hover"===this.openEvent&&window.matchMedia("(hover: hover)").matches&&window.matchMedia("(pointer: fine)").matches&&(this.button.addEventListener("mouseover",this.openModal.bind(this)),this.button.addEventListener("mouseout",this.startCheckingMouseLeave.bind(this)),this.content.addEventListener("mouseover",this.stopCheckingMouseLeave.bind(this)),this.content.addEventListener("mouseout",this.startCheckingMouseLeave.bind(this))),this.mobileOverlay&&this.mobileOverlay.addEventListener("click",this.closeModal.bind(this))}startCheckingMouseLeave(){this.checkingMouseLeave=!0,setTimeout(()=>{this.checkingMouseLeave&&this.closeModal()},200)}stopCheckingMouseLeave(){this.checkingMouseLeave=!1}toggleModal(){"true"!=this.dataset.open&&this.openModal()}openModal(){let t=this.header?.clientHeight||0;(this.header?.classList.contains("shopify-section-header-hidden")||!this.stickyHeader)&&(t=0);this.content.getBoundingClientRect().top-t<0&&(this.dataset.direction="bottom"),this.dataset.open="true"}closeModal(){this.dataset.open="false",setTimeout(()=>{this.dataset.direction=""},100)}connectedCallback(){registerHotspotButton(this)}disconnectedCallback(){unregisterHotspotButton(this)}}
define('v4-hotspot-button',HotspotButton);
class CartDrawerGift extends HTMLElement {
    connectedCallback() {
      if (this.dataset.runtimeBound) {
        document.addEventListener('cart:updated', this.onCartUpdated);
        return;
      }
      this.dataset.runtimeBound = 'true';
      this.onCartUpdated = (event) => this.update(event.detail.cart);
      document.addEventListener('cart:updated', this.onCartUpdated);
      this.querySelectorAll('.upsell__variant-picker select').forEach((select) => {
        select.addEventListener('change', () => this.updateVariant());
      });
      // Central reconciliation runs after cart mutations, never during DOM reconstruction.
    }

    updateVariant() {
      const variants = parseJsonScript(this);
      if (!variants.length) return;
      const picker = this.querySelector('.upsell__variant-picker') || this;
      const variant = resolveSelectableVariant(picker, variants, {
        skipUnavailable: true,
        skipNonExistent: true,
      });
      if (!variant || !variant.available || Number(variant.price) !== 0) {
        this.dataset.variantAvailable = 'false';
        return;
      }
      this.dataset.variantAvailable = 'true';
      this.dataset.id = String(variant.id);
      const input = this.querySelector('input[name="id"]');
      if (input) input.value = String(variant.id);
      this.update();
    }

    setUnlocked(unlocked) {
      this.dataset.selected = String(unlocked);
      this.classList.toggle('is-unlocked', unlocked);
    }

    update(cart = null) {
      if(this.updatePromise)return this.updatePromise;
      this.updatePromise=DBCommerce.run(async()=>{const result=await this.reconcileGift(cart);await DBCommerce.refresh();return result}).catch(error=>{DBCommerce.error(document.querySelector('#CartDrawer .drawer__inner')||this,error.message);throw error}).finally(()=>{this.updatePromise=null});
      return this.updatePromise;
    }

    getGiftItems(cart) {
      const key = String(this.dataset.giftKey || '');
      return (cart?.items || []).filter((item) => itemProperty(item, '_theme_gift_key') === key);
    }

    findGiftMismatch(cart, unlocked) {
      const giftItems = this.getGiftItems(cart);
      const desiredId = Number(this.dataset.id);
      const desiredItem = giftItems.find((item) => Number(item.variant_id || item.id) === desiredId);
      const staleItem = giftItems.find((item) => Number(item.variant_id || item.id) !== desiredId);
      const duplicateItem = giftItems.find((item) => item !== desiredItem && Number(item.variant_id || item.id) === desiredId);
      if (!unlocked && giftItems[0]) return { action: 'remove', cartItem: giftItems[0] };
      if (unlocked && !desiredItem) return { action: 'add' };
      if (unlocked && desiredItem && Number(desiredItem.quantity || 0) !== 1) {
        return { action: 'change', cartItem: desiredItem, quantity: 1 };
      }
      if (unlocked && staleItem) return { action: 'remove', cartItem: staleItem };
      if (unlocked && duplicateItem) return { action: 'remove', cartItem: duplicateItem };
      return null;
    }

    async reconcileGift(initialCart = null) {
      let state = initialCart?.items ? initialCart : await this.fetchCart();
      const giftItems = this.getGiftItems(state);
      const primaryItems = (state.items || []).filter((item) => !(
        itemProperty(item, '_db_addon')
        || itemProperty(item, '_theme_upsell_key')
        || itemProperty(item, '_theme_gift_key')
        || itemProperty(item, '_theme_additional_key')
      ));
      const basis = this.dataset.type === 'product_quantity'
        ? primaryItems.reduce((sum, item) => sum + Number(item.quantity || 0), 0)
        : primaryItems.reduce((sum, item) => sum + Number(item.final_line_price ?? item.line_price ?? 0), 0);
      const unlocked = primaryItems.length > 0
        && this.dataset.variantAvailable !== 'false'
        && basis >= Number(this.dataset.requirement || 0);
      this.setUnlocked(unlocked);

      if (window.Shopify?.designMode) return { changed: false, cart: state };
      let mismatch = this.findGiftMismatch(state, unlocked);
      let changed = false;
      let attemptsRemaining = Math.max(6, state.items.length + 2);
      while (mismatch && attemptsRemaining > 0) {
        const result = await this.applyGiftMismatch(mismatch);
        state = mismatch.action !== 'add' && isFullCart(result) ? result : await this.fetchCart();
        changed = true;
        attemptsRemaining -= 1;
        mismatch = this.findGiftMismatch(state, unlocked);
      }
      if (mismatch) throw new Error('Gift cart state could not be synchronized.');
      return { changed, cart: state };
    }

    async fetchCart() { return DBCommerce.cart(); }

    async applyGiftMismatch(mismatch) {
      this.dataset.loading = 'true';
      try {
        const body = mismatch.action === 'add'
          ? {
              items: [{
                id: Number(this.dataset.id),
                quantity: 1,
                properties: { _theme_gift_key: String(this.dataset.giftKey || '') },
              }],
              sections: [(document.querySelector('cart-drawer')?.dataset.sectionId || 'cart-drawer'), 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            }
          : {
              id: mismatch.cartItem?.key,
              quantity: mismatch.action === 'change' ? Number(mismatch.quantity || 1) : 0,
              sections: [(document.querySelector('cart-drawer')?.dataset.sectionId || 'cart-drawer'), 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            };
        if (mismatch.action !== 'add' && !body.id) throw new Error('Gift cart item could not be identified.');
        const state = await DBCommerce.post(mismatch.action === 'add' ? 'cart/add.js' : 'cart/change.js', body);
        return state;
      } finally {
        this.dataset.loading = 'false';
      }
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onCartUpdated);
    }
  }
define('v4-cart-drawer-gift',CartDrawerGift);
const eligibility={isDecorativeCartItem(item) {
      return Boolean(
        itemProperty(item, '_db_addon')
        || itemProperty(item, '_theme_upsell_key')
        || itemProperty(item, '_theme_gift_key')
        || itemProperty(item, '_theme_additional_key')
      );
    },hasPrimaryCartItem(cart) {
      return (cart?.items || []).some((item) => !this.isDecorativeCartItem(item));
    },findInvalidAdditionalItem(cart) {
      const items = cart?.items || [];
      if (!this.hasPrimaryCartItem(cart)) return items.find((item) => itemProperty(item, '_theme_additional_key') || itemProperty(item, '_theme_gift_key')) || null;
      return items.find((item) => {
        if (!itemProperty(item, '_theme_additional_key')) return false;
        const parentProductId = Number(itemProperty(item, '_theme_parent_product_id'));
        const minimum = Math.max(1, Number(itemProperty(item, '_theme_min_parent_quantity')) || 1);
        if (!parentProductId) return false;
        const parentQuantity = items.reduce((sum, candidate) => {
          if (this.isDecorativeCartItem(candidate)) return sum;
          return Number(candidate.product_id) === parentProductId
            ? sum + Number(candidate.quantity || 0)
            : sum;
        }, 0);
        return parentQuantity < minimum;
      }) || null;
    },async removeInvalidAdditionalItems(cart) {
      let state = cart;
      let changed = false;
      let invalid = this.findInvalidAdditionalItem(state);
      let attemptsRemaining = Math.max(2, (state?.items?.length || 0) + 1);
      while (invalid && attemptsRemaining > 0) {
        const result = await DBCommerce.post('cart/change.js', {id:invalid.key, quantity:0});
        state = result;
        changed = true;
        attemptsRemaining -= 1;
        invalid = this.findInvalidAdditionalItem(state);
      }
      if (invalid) throw new Error('Additional item eligibility could not be synchronized');
      return { changed, cart: state };
    }};
const sourceSelection=(form,quantity)=>{const info=form.closest('product-info')||form.closest('.product__info-container')||form.closest('.shopify-section');if(!info)return [];const parent=info.dataset.productId||info.querySelector('[data-product-id]')?.dataset.productId||'';return [...info.querySelectorAll('v4-quantity-gifts .quantity-gift[data-additional-key][data-product]')].filter(g=>quantity>=Number(g.dataset.quantity||1)).map(g=>({id:g.dataset.product,quantity:1,key:g.dataset.additionalKey,scope:'source',properties:{_theme_additional_key:g.dataset.additionalKey,_theme_parent_product_id:parent,_theme_min_parent_quantity:g.dataset.quantity||'1',_theme_additional_kind:'gift'}}));};
const active=()=>!!document.querySelector('v4-cart-drawer-gift, v4-quantity-gifts, v6-quantity-breaks, [data-theme-additional-key]:not([data-theme-additional-key=""]), [data-theme-gift-key]:not([data-theme-gift-key=""])');
async function reconcile(initial=null){if(window.Shopify?.designMode || !active())return {changed:false,cart:initial};let state=initial?.items?initial:await DBCommerce.cart();const clean=await eligibility.removeInvalidAdditionalItems(state);state=clean.cart;let changed=clean.changed;for(const gift of [...document.querySelectorAll('v4-cart-drawer-gift[data-id]')]){const result=await gift.reconcileGift(state);state=result.cart;changed=changed||result.changed;}return {changed,cart:state};}
window.DBSourceCommerce={selection:sourceSelection,reconcile,active};
// v4 prepareForCheckout intent: reconcile configured gifts before ordinary cart checkout.
// Reuse t4's queue, error handling and localized navigation rather than replacing its cart component.
document.addEventListener('submit',event=>{
  if(event.defaultPrevented || event.submitter?.name!=='checkout' || !active())return;
  event.preventDefault();
  DBCommerce.run(async()=>{await reconcile();DBCommerce.navigate(DBCommerce.url('checkout'));})
    .catch(error=>DBCommerce.error(document.querySelector('#CartDrawer .drawer__inner')||event.target,error.message));
});
})();
